module.exports = __webpack_public_path__ + "img/figuur.49cebe68.jpg";